<template>
  <div class="content">
    <controlbar
      :dispItems="adminAccounts"
      :checked="checked"
      @input-event="setAdminAccount"
      @list-reload="reload"
    >
    </controlbar>
    <div class="center">
      <table class="content_title" rules="rows">
        <tr class="items_table">
          <th class="table_checkbox">
            <input
              type="checkbox"
              class="checkbox"
              :checked="checked"
              @click="allCheckedAction"
            />
          </th>
          <td class="table_contents">
            <label class="system_user_id_label">
              {{ adminUserIdLabel }}
            </label>
          </td>
          <td class="table_contents">
            <label class="system_user_name_label">
              {{ adminUserNameLabel }}
            </label>
          </td>
          <td class="table_contents">
            <label class="mail_address_label">
              {{ mailAddressLabel }}
            </label>
          </td>
          <td class="table_contents">
            <label class="authority_label">
              {{ authorityLabel }}
            </label>
          </td>
        </tr>
      </table>

      <div class="table_scroll" :style="{height: tableHeight}">
        <table class="items_table" rules="rows">
          <tr
            class="item_table_row"
            v-for="dispAdminAccount in adminAccounts"
            :key="dispAdminAccount.adminUserId"
          >
            <th class="table_checkbox">
              <input
                type="checkbox"
                class="checkbox"
                v-model="dispAdminAccount.checked"
                @click="checkedAction(dispAdminAccount)"
              />
            </th>
            <td class="table_contents" @click="setActive(dispAdminAccount)">
              <label class="system_user_id">
                {{ dispAdminAccount.adminUserId }}
              </label>
            </td>
            <td class="table_contents" @click="setActive(dispAdminAccount)">
              <label class="system_user_name">
                {{ dispAdminAccount.adminUserName }}
              </label>
            </td>
            <td class="table_contents" @click="setActive(dispAdminAccount)">
              <label class="mail_address">
                {{ dispAdminAccount.mailAddress }}
              </label>
            </td>
            <td class="table_contents" @click="setActive(dispAdminAccount)">
              <label class="authority">
                {{ dispAdminAccount.authority }}
              </label>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="bottom">
      <pagination
        v-model="page"
        :records="total"
        :per-page="pageSize"
        :options="{texts: {count: '{from} - {to}/{count}件'}, chunk: 5}"
        @paginate="setAdminAccount(page - 1)"
      >
      </pagination>
    </div>
    <div class="false_modal_window" v-if="showFalseModal">
      <falseModalWindow :question="falseWord" @close="close">
      </falseModalWindow>
    </div>
    <div class="loading_modal_window" v-if="showloadingModal">
      <loadingModalWindow @close="close"> </loadingModalWindow>
    </div>
  </div>
</template>

<script>
import controlbar from './controlbar.vue'
import Pagination from 'vue-pagination-2'
import falseModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'

export default {
  data() {
    return {
      adminUserIdLabel: '管理者ID',
      adminUserNameLabel: '管理者名',
      mailAddressLabel: 'メールアドレス',
      authorityLabel: '管理者権限情報',
      showFalseModal: false,
      windowHeight: '',
      falseWord: '',
      checked: false,
      inputValue: '',
      showloadingModal: false,
      pageSize: 20,
      page: 1,
      prevTotal: 0,
      prevPageNo: 0,
      prevSearchWord: ''
    }
  },
  computed: {
    adminAccounts() {
      return this.$store.state.adminAccounts.adminAccounts
    },
    total() {
      if (
        (this.page - 1) * this.pageSize <=
        this.$store.state.adminAccounts.total
      ) {
        return this.$store.state.adminAccounts.total
      }
      return this.prevTotal
    },
    isOverPage() {
      return (
        (this.page - 1) * this.pageSize >= this.$store.state.adminAccounts.total
      )
    },
    lastPage() {
      const last = Math.ceil(
        this.$store.state.adminAccounts.total / this.pageSize
      )
      return last === 0 ? 1 : last
    },
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    tableHeight() {
      const otherHeight = 138
      return this.windowHeight - otherHeight + 'px'
    },
    browsingAccountFlg() {
      return this.$store.state.masters.browsingAccountFlg
    },
    loginUserAuthority() {
      return this.$store.state.masters.loginUser.authority
    },
    loginUserId() {
      return this.$store.state.masters.loginUser.adminUserId
    }
  },
  async created() {
    window.addEventListener('resize', this.handleResize)
    this.updateWindowHeight()
    this.$store.dispatch('adminAccounts/clearSelectedAccountList')
    this.$store.state.prevPageNo = 0
    this.$store.state.prevSearchWord = ''
    this.setAdminAccount(0)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  components: {
    controlbar,
    Pagination,
    falseModalWindow,
    loadingModalWindow
  },
  methods: {
    handleResize() {
      // ウィンドウサイズ変更時にリアルタイムでウィンドウサイズの値を更新
      this.updateWindowHeight()
    },
    updateWindowHeight() {
      this.windowHeight = window.innerHeight
    },
    allCheckedAction(e) {
      // リストのチェックボックスを全てチェックする。
      this.checked = !this.checked
      for (let i = 0; i < this.adminAccounts.length; i++) {
        this.adminAccounts[i].checked = this.checked
      }
      this.$store.dispatch(
        'adminAccounts/updateSelectedAccountList',
        this.adminAccounts
      )
    },
    checkedAction(account) {
      account.checked = !account.checked
      this.$store.dispatch('adminAccounts/updateSelectedAccountList', [account])
    },
    close(e) {
      this.showFalseModal = false
    },
    async reload() {
      this.$store.dispatch('adminAccounts/clearSelectedAccountList')
      await this.setAdminAccount(
        this.$store.state.prevPageNo,
        this.$store.state.prevSearchWord
      )
    },
    async setAdminAccount(pageNo, searchWord = null) {
      this.showloadingModal = true
      let focus = document.activeElement
      focus.blur()
      let loginUserData = []
      loginUserData.push(this.loginUserAuthority)
      loginUserData.push(this.loginUserId)
      try {
        searchWord =
          searchWord === null
            ? this.$store.state.prevSearchWord === null
              ? ''
              : this.$store.state.prevSearchWord
            : searchWord
        await this.$store.dispatch('adminAccounts/setAdminAccounts', {
          loginUserData: loginUserData,
          pageNo: pageNo,
          searchWord: searchWord
        })
        if (pageNo > 0) {
          if (this.isOverPage) {
            this.page = this.lastPage
          } else {
            this.page = pageNo + 1
          }
        } else {
          this.page = 1
        }
        this.$store.state.prevPageNo = pageNo
        this.$store.state.prevSearchWord = searchWord
        this.checked = false
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_290001
        let eventType = 3
        let reason = 'MSGCRC0069 '
        if (error.response) {
          this.falseWord =
            this.errorMsg.MSGCRC0069.name +
            this.errorMsg.MSGCRC0069.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.falseWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFalseModal = true
      }
      this.showloadingModal = false
    },
    async setActive(payload) {
      this.showloadingModal = true
      let tr = event.currentTarget.parentNode.parentNode.querySelectorAll('tr')
      for (let i = 0; i < tr.length; i++) {
        tr[i].className = 'item_table_row'
      }
      event.currentTarget.parentNode.className = 'item_table_row active'
      try {
        await this.$store.dispatch(
          'adminAccounts/setDetailAdminAccount',
          payload
        )
        if (location.pathname !== '/adminAccounts/detail') {
          this.$router.push('../adminAccounts/detail')
        }
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_290002
        let eventType = 3
        let reason = 'MSGCRC0070 '
        if (error.response) {
          this.falseWord =
            this.errorMsg.MSGCRC0070.name +
            this.errorMsg.MSGCRC0070.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.falseWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFalseModal = true
      }
      this.showloadingModal = false
    }
  }
}
</script>

<style scoped>
td {
  width: 25%;
}
</style>



// WEBPACK FOOTER //
// src/components/adminAccounts/adminAccountsList.vue